module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resetpassword"
  }, [_c('h1', [_vm._v("\n        Reset Your Password!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('vue-password', {
    staticClass: "form-input",
    attrs: {
      "minlength": 6,
      "classes": "input",
      "placeholder": "Password",
      "error": "Password",
      "id": "resetpassword_password",
      "disableStrength": _vm.hidePasswordMeter,
      "required": "",
      "icon": ""
    },
    model: {
      value: (_vm.forgetpassword.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.forgetpassword, "newPassword", $$v)
      },
      expression: "forgetpassword.newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-info-circled alert-icon-float-left information"
  }, [_c('p', {
    staticClass: "alert alert-info alert-dismissable",
    class: {
      'set-error': !_vm.verifyPassword()
    },
    attrs: {
      "id": "resetpassword_pwderrormsg"
    }
  }, [_vm._v("Min 6 Chars, One Upper Case, One Lower Case!")])])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "resetpassword_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "id": "resetpassword_reset"
    }
  }, [_vm._v("\n                    Reset Password\n                ")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb6d862"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/ResetPassword.vue